<template>
  <div class="crewHome">
    <div class="crewHome-content" style="position: relative">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick"
        class="unpass-position"
      >
        <el-tab-pane label="邀请船员" name="first"></el-tab-pane>
        <el-tab-pane label="投递船员" name="second"></el-tab-pane>
      </el-tabs>
      <!-- 用户管理 -->
      <el-form
        :inline="true"
        :model="formInline"
        class="other-form-inline"
        v-show="delVisible"
      >
        <!-- <el-form-item class="flex-form">
          <el-date-picker
            class="hide-icon"
            type="date"
            placeholder="开始时间"
            v-model="formInline.date1"
            style="width: 100px"
          ></el-date-picker>
          <span class="line" style="margin: 0 3px">-</span>
          <el-date-picker
            class="hide-icon"
            placeholder="结束时间"
            v-model="formInline.date2"
            style="width: 100px"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item>
          <el-input
            v-model="formInline.userName"
            placeholder="搜索名字"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form>
      <!-- 配置用户 -->
      <el-form
        :inline="true"
        :model="formInline2"
        class="other-form-inline"
        v-show="inviteVisible"
      >
        <el-form-item>
          <el-input
            v-model="formInline2.userName"
            placeholder="搜索名字"
            style="width: 150px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <div class="other-search" @click="onSubmit2">
            <i class="el-icon-search"></i>
          </div>
        </el-form-item>
      </el-form>
      <div style="clear: both"></div>
      <el-divider class="other-divider"></el-divider>
      <div class="other-table">
        <!-- 邀请 -->
        <el-table
          v-show="delVisible"
          :data="tableData"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == '0'">男</span>
              <span v-if="scope.row.sex == '1'">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="idCardNo" label="身份证号" min-width="140">
          </el-table-column>
          <el-table-column prop="cellphoneNo" label="联系方式" min-width="120">
          </el-table-column>
          <el-table-column prop="inviteTime" label="邀请时间" min-width="100">
          </el-table-column>
          <el-table-column label="操作" min-width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>
              <!-- <el-button type="text" size="small" class="other-watch">
                下载
              </el-button> -->
              <!-- <el-button
                type="text"
                size="small"
                class="other-del"
                @click="delInvite(scope)"
              >
                删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <!-- 投递 -->
        <el-table
          v-show="inviteVisible"
          :data="tableData2"
          style="width: 100%"
          header-row-class-name="other-header"
          row-class-name="other-row"
          height="100%"
        >
          <el-table-column prop="userName" label="姓名" min-width="100">
          </el-table-column>
          <el-table-column prop="sex" label="性别" min-width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.sex == '0'">男</span>
              <span v-if="scope.row.sex == '1'">女</span>
            </template>
          </el-table-column>
          <el-table-column prop="age" label="年龄" min-width="140">
          </el-table-column>
          <el-table-column prop="workingYear" label="航海经验" min-width="120">
          </el-table-column>
          <el-table-column prop="degreesName" label="学历" min-width="100">
          </el-table-column>
          <el-table-column prop="clientCompanyName" label="投递公司" min-width="120">
          </el-table-column>
          <el-table-column prop="sendPositionName" label="投递岗位" min-width="120">
          </el-table-column>
          <el-table-column prop="resumeSendTime" label="投递时间" min-width="100">
          </el-table-column>
          <el-table-column label="操作" min-width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                class="other-watch"
                @click="comDetail(scope)"
              >
                查看
              </el-button>
              <!-- <el-button type="text" size="small" class="other-watch">
                下载
              </el-button> -->
              <!-- <el-button
                type="text"
                size="small"
                class="other-del"
                @click="delInvite(scope)"
              >
                删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 投递 -->
      <div v-show="delVisible">
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage1"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 邀请 -->
      <div v-show="inviteVisible">
        <div class="other-block">
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="currentPage4"
            layout="total, prev, pager, next, jumper"
            :total="total2"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCrewInfo } from "@/apis/index";
export default {
  data() {
    return {
      formInline: {},
      formInline2: {},
      tableData: [],
      tableData2: [],
      currentPage1: 1,
      currentPage2: 5,
      currentPage3: 5,
      currentPage4: 1,
      companyVisible: false,
      formLabelAlign: {},
      activeName: "first",
      delVisible: true,
      inviteVisible: false,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      total2: 0,
    };
  },
  mounted() {
    // this.getTable();
    this.getCrewInfoList();
  },
  methods: {
    onSubmit() {
      this.pageNo = 1;
      this.getCrewInfoList();
    },
    onSubmit2() {
      this.pageNo = 1;
      this.getSendInfoList();
    },
    handleOpen() {},
    handleSizeChange(val) {
      this.pageSize = val;
      this.getCrewInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getCrewInfoList();
      // console.log(`当前页: ${val}`);
    },
    handleSizeChange2(val) {
      this.pageSize = val;
      this.getSendInfoList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange2(val) {
      this.pageNo = val;
      this.getSendInfoList();
      // console.log(`当前页: ${val}`);
    },
    choseCom() {
      this.companyVisible = true;
    },
    handleClose() {
      this.companyVisible = false;
    },
    comDetail(item) {
      // console.log(scope);
      // let name = scope.row.date1;
      // console.log(name);
      this.$router.push({
        name: "inviteDetail3",
        params: { name: item.row.userName, userId: item.row.userId,passFlag:'2' },
      });
    },
    handleClick(tab) {
      if (tab.name == "first") {
        this.delVisible = true;
        this.inviteVisible = false;
        this.getCrewInfoList();
      } else {
        this.pageNo = 1;
        this.delVisible = false;
        this.inviteVisible = true;
        this.getSendInfoList();
      }
    },
    async getCrewInfoList() {
      let res = await getCrewInfo({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        agentAuditState: "3",
        userOrigin: "2",
        ...this.formInline,
      });
      this.total2 = res.data.rowCount;
      this.tableData = res.data.resultList;
      res.data.resultList.forEach(item => {
        if (item.inviteTime) {
          item.inviteTime = item.inviteTime.split(" ")[0];
        }
      });
    },
    async getSendInfoList() {
      let res = await getCrewInfo({
        pageSize: this.pageSize,
        pageNo: this.pageNo,
        agentAuditState: "3",
        userOrigin: "3",
        ...this.formInline,
      });
      this.total = res.data.rowCount;
      res.data.resultList.forEach(item => {
        if (item.resumeSendTime) {
          item.resumeSendTime = item.resumeSendTime.split(" ")[0];
        }
      });
      this.tableData2 = res.data.resultList;
    },
    delInvite(scope) {
      this.$confirm("确定要淘汰吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 执行删除操作
          // this.$message({
          //   message: "删除成功",
          //   type: "success",
          // });
          this.delList(scope.row.userId);
          // console.log(scope);
        })
        .catch(() => {
          // 取消删除操作
          console.log("取消删除");
        });
    },
    async delList() {
      // await crewAudit({ userId: item, agentAuditState: "3" });
      // console.log(res);
      this.getCrewInfoList();
    },
  },
};
</script>
